import { useEffect, useState } from "react";
import { api, money, dateTime } from "../api.js";
import { SectionHead, PartialErrors, Empty } from "./common.jsx";

// Колонки — поля ta/splatp кабінету (стан розрахунків з бюджетом за рік)
const COLS = [
  ["nedoim0", "Недоїмка на початок"], ["perepl0", "Переплата на початок"],
  ["narahEnd", "Нараховано"], ["splbdEnd", "Сплачено"], ["povbdEnd", "Повернено"], ["peniaEnd", "Пеня"],
  ["nedoimEnd", "Недоїмка"], ["pereplEnd", "Переплата"],
];
const n = (v) => Number(v) || 0;

function Year({ y }) {
  if (!y.rows) return <Empty>За {y.year} рік даних ще немає.</Empty>;
  if (!y.rows.length) return <Empty>За {y.year} рік розрахунків немає.</Empty>;
  const total = Object.fromEntries(COLS.map(([k]) => [k, y.rows.reduce((a, r) => a + n(r[k]), 0)]));
  return (
    <div className="table-wrap">
      <table className="table-static table-budget">
        <thead>
          <tr><th>Платіж і ДПІ</th>{COLS.map(([k, t]) => <th key={k} className="num">{t}</th>)}</tr>
        </thead>
        <tbody>
          {y.rows.map((r, i) => (
            <tr key={r.idpmnt ?? i}>
              <td className="pay-cell">
                <span>{(r.namePlt || "").trim()}</span>
                <span className="muted">{r.nameSti}</span>
                <span className="muted mono-sm">{r.plat1}</span>
              </td>
              {COLS.map(([k]) => (
                <td key={k} className={`num${k === "nedoimEnd" && n(r[k]) > 0 ? " error" : ""}`}>{money(r[k] ?? 0)}</td>
              ))}
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr><th>Разом</th>{COLS.map(([k]) => <th key={k} className="num">{money(total[k])}</th>)}</tr>
        </tfoot>
      </table>
    </div>
  );
}

export default function Budget({ companyId, res, version, onSync }) {
  const [data, setData] = useState(null);
  useEffect(() => { api(`/api/companies/${companyId}/budget`).then(setData); }, [companyId, version]);
  return (
    <>
      <SectionHead title="Розрахунки з бюджетом" res={res} onSync={onSync} />
      <PartialErrors res={res} />
      {!data ? <p className="muted">Завантаження…</p> : data.years.map((y) => (
        <section key={y.year} className="card">
          <div className="row">
            <h3>{y.year}</h3>
            {y.fetchedAt && <span className="muted">на {dateTime(y.fetchedAt)}{y.source === "official" ? " · офіційний API" : ""}</span>}
          </div>
          <Year y={y} />
        </section>
      ))}
    </>
  );
}
